import { AddressType, PackageDimensions } from '@onrunning/backstage-models';
import { commonUnitsPerLocale } from '../constants/measurements.contants';
import { AccountAddress } from './account-address.model';
import { CaseContact } from './case-contact.model';

export enum YesNoOptions {
  yes = 'yesOption',
  no = 'noOption',
}

export class CasePickupModel {
  addressNotes?: string;
  returnReason: string;
  contact: CaseContact;
  address?: AccountAddress;
  customerReference: string;
  restrictedAccess: boolean;
  tailLiftRequired: boolean;
  description?: string;
  pickupDate!: Date;
  parcelCount?: number;
  palletCount?: number;
  totalPackageWeight: number;
  singlePackageWeight: number;
  weightUnit: string;
  dimensions: PackageDimensions;

  constructor() {
    this.addressNotes = '';
    this.returnReason = '';
    this.contact = {
      email: '',
      name: '',
      countryCode: '',
      phone: '',
      country: '',
    };
    this.address = {
      addressType: '' as unknown as AddressType,
      streetDescription: '',
      city: '',
      country: '',
      state: '',
      street: '',
      zipCode: '',
    };
    this.customerReference = '';
    this.restrictedAccess = false;
    this.tailLiftRequired = false;
    this.description = '';
    this.parcelCount = 0;
    this.palletCount = 0;
    this.totalPackageWeight = 0;
    this.singlePackageWeight = 0;
    this.weightUnit = commonUnitsPerLocale['en-GB'].weight;
    this.dimensions = {
      height: 0,
      width: 0,
      length: 0,
      unit: commonUnitsPerLocale['en-GB'].length,
    };
  }
}
